// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es el Red Teaming?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            Nuestros servicios de Red Team simulan amenazas cibernéticas reales para evaluar la seguridad de tu organización. Nuestros expertos realizan evaluaciones exhaustivas, pruebas de penetración y ataques simulados para descubrir vulnerabilidades. También evaluamos la madurez de tu defensa tratando de ser sigilosos, ayudando a identificar debilidades o puntos ciegos, lo que te ayuda a fortalecer las defensas contra escenarios reales.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave del Red Teaming
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="view_in_ar"
                title="Simulación de Amenazas del Mundo Real"
                description="El Red Teaming emula las tácticas, técnicas y procedimientos (TTPs) empleados por adversarios cibernéticos sofisticados. Esto incluye probar la capacidad de una organización para detectar y responder a amenazas persistentes avanzadas (APTs), amenazas internas, ataques de ingeniería social y más."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="key"
                title="Pruebas Basadas en Escenarios"
                description="Los equipos de Red Team crean escenarios personalizados que imitan diversas amenazas cibernéticas, adaptando su enfoque a la organización específica y su industria. Esto permite a las organizaciones evaluar su preparación ante una amplia gama de vectores de ataque potenciales."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="trending_up"
                title="Adaptativo y Evolutivo"
                description="Las actividades del Red Team son dinámicas y se adaptan al panorama de amenazas en evolución. Los equipos de Red Team refinan continuamente sus tácticas y técnicas para reflejar las últimas amenazas y vulnerabilidades cibernéticas."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="pentagon"
                title="Análisis Integral"
                description="Las evaluaciones del Red Team abarcan vulnerabilidades técnicas, factores humanos y la cultura general de seguridad. Este enfoque holístico proporciona a las organizaciones una visión completa de su postura de seguridad."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa el Red Teaming?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="bolt"
                title="Defensa Proactiva"
                description="El Red Teaming permite a las organizaciones identificar y remediar proactivamente las vulnerabilidades antes de que los actores malintencionados puedan explotarlas. Este enfoque proactivo es invaluable en el panorama de amenazas actual."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="public"
                title="Pruebas Realistas"
                description="Al simular escenarios de ataque del mundo real, el Red Teaming proporciona a las organizaciones una evaluación realista de su preparación y resiliencia en seguridad."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="settings_account_box"
                title="Soluciones Personalizadas"
                description="Las actividades del Red Teaming se adaptan a las necesidades únicas de la organización, asegurando que los hallazgos y recomendaciones sean altamente relevantes y accionables."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="restart_alt"
                title="Mejora Continua"
                description="Las evaluaciones del Red Team a menudo implican probar la conciencia de seguridad y las capacidades de respuesta de una organización, ayudando a fomentar una cultura de preparación en ciberseguridad."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de los Red Teams en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            Los Red Teams actúan como hackers éticos, probando las defensas de una organización para exponer debilidades que podrían ser explotadas por actores malintencionados. Sus hallazgos se utilizan para informar estrategias de seguridad, esfuerzos de remediación y mejoras continuas. En esencia, el Red Teaming es un componente vital de una estrategia integral de ciberseguridad, ayudando a las organizaciones no solo a defenderse contra amenazas actuales, sino también a anticipar y prepararse para futuros desafíos en el siempre cambiante panorama de la ciberseguridad.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;